const KEY_TOKEN = "token";
const KEY_ACCOUNT_INFO = "accountInfo";
const KEY_RTE = "rte";
const KEY_DATE = "date";
const KEY_EDU_DATE = "edudate";
const KEY_COMPANY = 'company'


export default {

  saveToken(token) {
    sessionStorage[KEY_TOKEN] = token;
  },
  getToken() {
    return sessionStorage[KEY_TOKEN];
  },


  saveDate(date) {
    sessionStorage[KEY_DATE] = date;
  },
  getDate() {
    return sessionStorage[KEY_DATE];
  },

  saveEduDate(date) {
    sessionStorage[KEY_EDU_DATE] = date;
  },
  getEduDate() {
    return sessionStorage[KEY_EDU_DATE];
  },

  saveCompany(data) {
    sessionStorage[KEY_COMPANY] = JSON.stringify(data);
  },
  getCompany() {
    return JSON.parse(sessionStorage[KEY_COMPANY] || '{}');
    ;
  },


  saveRte(type) {
    this.rte = type;
    sessionStorage[KEY_RTE] = JSON.stringify(type);
  },
  getRte() {
    return JSON.parse(sessionStorage[KEY_RTE] || '{}');
    ;
  },


  saveBaseInfo(accountInfo) {
    let user = accountInfo.user;
    if (!user || typeof user !== 'object') {
      accountInfo.user = {};
    }
    sessionStorage[KEY_ACCOUNT_INFO] = JSON.stringify(accountInfo);
  },

  getBaseInfo() {
    return JSON.parse(sessionStorage[KEY_ACCOUNT_INFO] || '{}');
  },


  clear() {
    sessionStorage[KEY_TOKEN] = "";
    sessionStorage[KEY_RTE] = "";
    sessionStorage[KEY_ACCOUNT_INFO] = "";
  }
}



// WEBPACK FOOTER //
// ./src/persistence/UserPersistence.js